import styled from 'styled-components';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  overflow-y: auto;
  padding: 2rem 0;

  .form-container {
    background: var(--clr-white);
    padding: 2rem;
    border-radius: var(--radius);
    width: 90%;
    max-width: 500px;
    max-height: 90vh;
    overflow-y: auto;
  }

  .title {
    text-align: center;
    margin-bottom: 1.5rem;
    h3 {
      margin-bottom: 0.5rem;
      color: var(--clr-primary-5);
    }
    p {
      color: var(--clr-grey-5);
    }
  }

  .order-summary {
    background: var(--clr-grey-10);
    padding: 1rem;
    border-radius: var(--radius);
    margin-bottom: 1.5rem;
    
    h4 {
      margin-bottom: 0.75rem;
      color: var(--clr-primary-5);
    }
    
    p {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.5rem;
      font-size: 0.9rem;
    }
    
    span:first-child {
      font-weight: 600;
    }

    .color-box {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      display: inline-block;
      border: 1px solid var(--clr-grey-5);
    }
    
    hr {
      margin: 0.75rem 0;
      border: none;
      border-top: 1px solid var(--clr-grey-5);
    }
    
    .total {
      font-weight: 700;
      font-size: 1.1rem;
      color: var(--clr-primary-5);
    }
  }

  form {
    .form-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1rem;
    }

    .form-control {
      margin-bottom: 1rem;
    }

    .input {
      width: 100%;
      padding: 0.75rem;
      background: var(--clr-grey-10);
      border-radius: var(--radius);
      border: 1px solid transparent;
      letter-spacing: var(--spacing);
      font-size: 1rem;
      transition: border-color 0.3s ease;

      &:focus {
        border-color: var(--clr-primary-5);
        outline: none;
      }
    }

    .input::placeholder {
      text-transform: capitalize;
      color: var(--clr-grey-5);
    }

    .sort-input {
      border-color: transparent;
      font-size: 1rem;
      text-transform: capitalize;
      cursor: pointer;
    }

    .btn-container {
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
      margin-top: 1rem;
    }

    .btn {
      padding: 0.75rem 1rem;
      border-radius: var(--radius);
      cursor: pointer;
      font-size: 1rem;
      text-transform: capitalize;
      transition: all 0.3s ease;
    }

    .confirm-btn {
      background: var(--clr-primary-5);
      color: var(--clr-white);
      border: none;

      &:hover {
        background: var(--clr-primary-7);
      }

      &:disabled {
        background: var(--clr-grey-5);
        cursor: not-allowed;
      }
    }

    .cancel-btn {
      background: transparent;
      color: var(--clr-red-dark);
      border: 1px solid var(--clr-red-dark);

      &:hover {
        background: var(--clr-red-dark);
        color: var(--clr-white);
      }
    }
  }

  @media (max-width: 576px) {
    .form-container {
      width: 95%;
      padding: 1.5rem;
    }

    form .form-row {
      grid-template-columns: 1fr;
    }
  }
`;

export default Wrapper;
